import { dateAndTimeFormatter } from '../../../../utils/dateFormatter';

export class ChatroomModel {
  id?: number;
  name: string = '';
  ChatroomUsers?: Array<any>;
  messages?: Array<any>;
  createdAt?: string;

  constructor(data: any) {
    if (data.hasOwnProperty('id')) this.id = data.id;
    if (data.hasOwnProperty('name')) this.name = data.name;
    if (data.hasOwnProperty('ChatroomUsers')) this.ChatroomUsers = data.ChatroomUsers;
    if (data.hasOwnProperty('messages')) this.messages = data.messages;
    if (data.hasOwnProperty('createdAt'))
      this.createdAt = dateAndTimeFormatter(data.createdAt).split(';')[0] + '';
  }
}
